module.exports = __webpack_public_path__ + "static/media/edit-2.42553ad4.svg";